import React, { useState } from 'react';
import './inspectionmanual.css'
import DownloadingIcon from '@mui/icons-material/Downloading';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const InspectionManual = () => {
    const [isFeaturesExpanded, setIsFeaturesExpanded] = useState(false);

  const redirectToWhatsapp = (msg) => {
    window.open(msg, '_blank');
  };

  const checklistFeatures = [
    "What is a Home Inspection?",
    "Home Inspection Tools",
    "Qualities of Home Inspector",
    "Comprehensive defect identification",
    "Visual examination guidelines", 
    "Home Inspection booking guidelines; When? How? Where?"
  ];

  const checklistStats = [
    { number: "100+", label: "Check Points" },
    { number: "10", label: "Major Systems" },
    { number: "Free", label: "Get Your Copy Now!" },
    { number: "100%", label: "Comprehensive" }
  ];

  return (
    <div className="inspection-manual-card">
      <div className="inspection-manual-header">
        <div className="inspection-manual-badge">
          <MenuBookIcon className="badge-icon" />
          <span>Free Download</span>
        </div>
        <h1 className="inspection-manual-title">Home Inspection Checklist</h1>
        <p className="inspection-manual-description">
          A comprehensive guide for homebuyers to identify and document defects in a property, ensuring a thorough evaluation before purchase!
        </p>
      </div>

      <div className="checklist-content">
        <div className="checklist-card-header">
          <div className="checklist-icon">
            <MenuBookIcon className="card-icon" />
          </div>
          <h2 className="checklist-card-title">Comprehensive Home Inspection Checklist</h2>
        </div>
        
        <div className="checklist-description">
          <p>Our comprehensive home inspection checklist provides you with everything you need to identify and document defects in your new property.</p>
        </div>

        <div className={`checklist-features ${!isFeaturesExpanded ? 'collapsed' : ''}`}>
          <div 
            className="features-header" 
            onClick={() => setIsFeaturesExpanded(!isFeaturesExpanded)}
          >
            <h3 className="features-title">What's Included:</h3>
            {isFeaturesExpanded ? (
              <ExpandLessIcon className="expand-icon" />
            ) : (
              <ExpandMoreIcon className="expand-icon" />
            )}
          </div>
          <div className={`features-content ${isFeaturesExpanded ? 'expanded' : 'collapsed'}`}>
            <div className="features-grid">
              {checklistFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <CheckCircleIcon className="feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="checklist-stats">
          <h3 className="stats-title">Checklist Statistics</h3>
          <div className="stats-grid">
            {checklistStats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="checklist-benefits">
          <div className="benefit-item">
            <div className="benefit-icon">🔍</div>
            <div className="benefit-text">
              <h4>Visual Examination</h4>
              <p>Identify significant defects that might be overlooked</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">🛠️</div>
            <div className="benefit-text">
              <h4>Advanced Tools</h4>
              <p>Comprehensive inspection using professional equipment</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">📋</div>
            <div className="benefit-text">
              <h4>Detailed Reports</h4>
              <p>Document all findings for informed decision making</p>
            </div>
          </div>
        </div>

        <div className="checklist-cta">
          <button 
            className="download-button" 
            onClick={() => redirectToWhatsapp("https://api.whatsapp.com/send/?phone=7304367001&text=Hello%2C+Please+Share+Home+Inspection+Checklist%20!%20Thanks&type=phone_number&app_absent=0")}
          >
            <DownloadingIcon className="button-icon" />
            <span>Get Your Free Copy Now!</span>
            <ArrowForwardIcon className="button-arrow" />
          </button>
          <p className="download-note">Download instantly via WhatsApp</p>
        </div>
      </div>
    </div>
  )
}

export default InspectionManual
